module.exports = __webpack_public_path__ + "assets/images/project/menu/united-arab-emirates-thumb.jpg?v=72176c89";